<template>
  <section class="main-board templates-board media-board">
    <div class="container quiz-by-template_head">
      <div class="header_search_block">
        <div class="search-input">
          <input type="text" class="template_search_input" name="" id="" :placeholder="$t('QuizTemplatesSearchInput', this.selectedTemplateLocale)"
                 v-model="searchInput" @input="clickSearchButton">
        </div>
        <div class="header_languages">
          <LanguageSelectorSecondVersion @change-locale="changeLocale" :activeLanguage="selectedTemplateLocale" />
        </div>
      </div>
      <div class="block_close" @click="closeModal"></div>
    </div>
    <div class="container" :style="'opacity:' + opacityBody" id="main-container" style="min-height: 100%; max-width: 100%;">
      <div class="templates_top_panel" id="templates_top_panel"
           style="overflow: hidden !important; overflow-anchor: none;touch-action: auto; padding-bottom: 0">
        <perfect-scrollbar>
          <div class="templates_tags_wrap-gray" id="tags_wrap" :style="'opacity:' + opacityBody"
               style="display: flex; opacity: 1; flex-direction: column; align-items: flex-start; height: 100%;">
            <input type="radio" name="quiz_tag" checked="true" value="all_tags" class="tag-checkbox"
                   id="tag_all" @click="handleCheckboxClick()">
            <label for="tag_all" class="tag_label">{{ $t('quizzesTemplatesAllTags', this.selectedTemplateLocale) }}</label>

            <template v-if="userInfo.role == 'admin'">
              <input type="radio" name="quiz_tag" value="no_tags" class="tag-checkbox" id="tag_no_tags"
                     @click="handleCheckboxClick()">
              <label for="tag_no_tags" class="tag_label">{{ $t('quizzesTemplatesNoTags', this.selectedTemplateLocale) }}</label>
            </template>

            <template v-for="(tag, index) in allQuizzesTags" :key="index">
              <input type="radio" name="quiz_tag" :value="tag" class="tag-checkbox" :id="'tag_' + index"
                     @click="handleCheckboxClick()">
              <label :for="'tag_' + index" class="tag_label">{{ tag }}</label>
            </template>
          </div>
        </perfect-scrollbar>
      </div>
      <div class="quizes-scroll-box scroll-pane scroll-f5f5f5"
           :style="'opacity:' + opacityBody + '; height:' + templatesWrapH + 'px'">
        <perfect-scrollbar ref="templatesScrollWrap" style="background: #F5F5F5">
          <div class="quizes-box templates-box" id="all_template_box" style="background: #F5F5F5; padding: 20px; margin: 0">
            <div class="quiz-box quiz-new" @click="createNewQuiz()">
              <svg style="z-index:2" width="40" height="40" viewBox="0 0 40 40" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="20.2533" cy="20.0238" rx="15.3333" ry="15.3333" fill="#3749C0"/>
                <rect x="19.4102" y="15.0234" width="1.66949" height="10" rx="0.834744" fill="white"/>
                <rect x="25.2539" y="19.2402" width="1.66949" height="10" rx="0.834744"
                      transform="rotate(90 25.2539 19.2402)"
                      fill="white"/>
              </svg>
              <p>{{ $t('workboardModalNewQuizFromStart', this.selectedTemplateLocale) }}</p>
            </div>
            <template v-if="quizzesData.length">
              <template v-for="(quiz) in quizzesData" :key="quiz.id">
                <div class="quiz-box" :id="'template_quiz_' + quiz.id" :data-id="quiz.id" data-tags="">
                  <div class="quiz_template_img-tags_wrap">
                    <div class="quiz_tags">
                      <template v-for="(tag, index) in quiz.tags" :key="index">
                        <span>{{ tag }}</span>
                      </template>
                      <template v-if="userInfo.role == 'admin'">
                         <span> <a target="_blank" class="" :href="frontAppUrl + '/' + quiz.code + '/admin-settings'">{{
                             $t('EditTags', this.selectedTemplateLocale)
                           }}</a></span>
                      </template>
                    </div>
                    <img v-if="quiz.start_page?.photo" loading="lazy" :src="quiz.start_page?.photo?.filename" alt="" >
                    <img v-else src="https://app.adsquiz.io/img/default-startpage-bg.jpeg" alt="">
                    <div class="quiz-text">
                      <p class="qb_text_block">{{ quiz.name }}</p>
                    </div>
                  </div>
                  <div class="quiz-icons">
                    <svg @click="goToQuiz(quiz.domain)" width="49" height="49" viewBox="0 0 49 49" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                      <circle cx="24.5" cy="24.5" r="20" fill="white"/>
                      <g clip-path="url(#clip0_7393_4701)">
                        <path
                            d="M35.6853 24.1962C35.6525 24.1222 34.8584 22.3606 33.0931 20.5953C30.7409 18.2431 27.77 17 24.5 17C21.23 17 18.2591 18.2431 15.9069 20.5953C14.1416 22.3606 13.3437 24.125 13.3147 24.1962C13.272 24.2922 13.25 24.396 13.25 24.5009C13.25 24.6059 13.272 24.7097 13.3147 24.8056C13.3475 24.8797 14.1416 26.6403 15.9069 28.4056C18.2591 30.7569 21.23 32 24.5 32C27.77 32 30.7409 30.7569 33.0931 28.4056C34.8584 26.6403 35.6525 24.8797 35.6853 24.8056C35.7279 24.7097 35.75 24.6059 35.75 24.5009C35.75 24.396 35.7279 24.2922 35.6853 24.1962ZM24.5 30.5C21.6144 30.5 19.0934 29.4509 17.0066 27.3828C16.1503 26.5313 15.4218 25.5603 14.8437 24.5C15.4216 23.4396 16.1501 22.4686 17.0066 21.6172C19.0934 19.5491 21.6144 18.5 24.5 18.5C27.3856 18.5 29.9066 19.5491 31.9934 21.6172C32.8514 22.4684 33.5815 23.4394 34.1609 24.5C33.485 25.7619 30.5403 30.5 24.5 30.5ZM24.5 20C23.61 20 22.7399 20.2639 21.9999 20.7584C21.2599 21.2529 20.6831 21.9557 20.3425 22.7779C20.0019 23.6002 19.9128 24.505 20.0865 25.3779C20.2601 26.2508 20.6887 27.0526 21.318 27.682C21.9473 28.3113 22.7492 28.7399 23.6221 28.9135C24.495 29.0872 25.3998 28.9981 26.2221 28.6575C27.0443 28.3169 27.7471 27.7401 28.2416 27.0001C28.7361 26.26 29 25.39 29 24.5C28.9988 23.3069 28.5242 22.163 27.6806 21.3194C26.837 20.4757 25.6931 20.0012 24.5 20ZM24.5 27.5C23.9066 27.5 23.3266 27.3241 22.8333 26.9944C22.3399 26.6648 21.9554 26.1962 21.7284 25.6481C21.5013 25.0999 21.4419 24.4967 21.5576 23.9147C21.6734 23.3328 21.9591 22.7982 22.3787 22.3787C22.7982 21.9591 23.3328 21.6734 23.9147 21.5576C24.4967 21.4419 25.0999 21.5013 25.648 21.7284C26.1962 21.9554 26.6648 22.3399 26.9944 22.8333C27.324 23.3266 27.5 23.9067 27.5 24.5C27.5 25.2956 27.1839 26.0587 26.6213 26.6213C26.0587 27.1839 25.2956 27.5 24.5 27.5Z"
                            fill="#3749C0"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_7393_4701">
                          <rect width="24" height="24" fill="white" transform="translate(12.5 12.5)"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <svg @click="duplicateQuiz(quiz.id, quiz.name)" width="49" height="49" viewBox="0 0 49 49"
                         fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="24.5" cy="24.5" r="20" fill="#3749C0"/>
                      <g clip-path="url(#clip0_7393_4702)">
                        <path
                            d="M20.5 19.5H17.5C16.3954 19.5 15.5 20.3954 15.5 21.5V30.5C15.5 31.6046 16.3954 32.5 17.5 32.5H31.5C32.6046 32.5 33.5 31.6046 33.5 30.5V21.5C33.5 20.3954 32.6046 19.5 31.5 19.5H28.5M27.5 23.5L24.5 26.5M24.5 26.5L21.5 23.5M24.5 26.5L24.5 16.5"
                            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_7393_4702">
                          <rect width="24" height="24" fill="white" transform="translate(12.5 12.5)"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </perfect-scrollbar>
        <loader-full-screen :is-show-loader="fullScreenLoader" @click="fullScreenLoader=false"/>
      </div>
    </div>
  </section>
</template>
<script>

/* Import */
import axios from "axios"
import {delay} from 'lodash'
import LanguageSelectorSecondVersion from "@/components/common/LanguageSelectorSecondVersion.vue";
import LoaderFullScreen from "@/components/ui/LoaderFullScreen.vue";

export default {
  name: "ModalTemplates",
  components: { LoaderFullScreen, LanguageSelectorSecondVersion },
  emits: ["addNewQuiz", "showLoader", "hideLoader", "close"],
  data() {
    return {
      selectedTemplateLocale: this.$i18n.locale,
      baseBackendUrl: process.env.VUE_APP_BASE_URL,
      frontAppUrl: process.env.VUE_APP_FRONT_URL,
      baseUserIdent: process.env.VUE_APP_USER_IDENT,
      baseQuizzesIdent: process.env.VUE_APP_QUIZZES_IDENT,
      opacityBody: '0',
      nameNewQuiz: '',
      fullScreenLoader: false,
      interval: null,
      mainContainerHeight: 0,
      topPanelH: 0,
      templatesWrapH: 0,
      isAuthenticated: true,
      quizzesData: [
        {
          id: "0",
          name: "(hook) Англійська мова",
          code: "rGhcP1jrdG",
          domain: "rghcp1jrdg.adsquiz.io",
          is_template: true,
          tags: ["Marketing", "Stydy"],
          start_page: {
            description: "Пройди опитування та отримай готовий раціон індівідуального харчування",
            photo: {
              filename: ""
            }
          },
          options: {
            lang: null,
          }
        },
        {
          id: "1",
          name: "Англійська мова",
          code: "fyGOiZ6NXA",
          domain: "fygoiz6nxa.adsquiz.io",
          is_template: true,
          tags: ["Marketing", "Food"],
          start_page: {
            description: "Пройди опитування та нічого не отримай",
            photo: {
              filename: ""
            }
          },
          options: {
            lang: null,
          }
        },
        {
          id: "2",
          name: "App sdsds dsds dsd dsdsdsdsd ds",
          code: "FNIPKg7Tgr",
          domain: "rghcp1jrdg.adsquiz.io",
          is_template: true,
          tags: ["Food"],
          start_page: {
            description: "Пройди опитування та отримай готовий раціон індівідуального харчування",
            photo: {
              filename: ""
            }
          },
          options: {
            lang: null,
          }
        },
        {
          id: "3",
          name: "tarry.ml",
          code: "nHZIwZInId",
          domain: "rghcp1jrdg.adsquiz.io",
          is_template: true,
          tags: ["Marketing"],
          start_page: {
            description: "Пройди опитування та отримай готовий раціон індівідуального харчування",
            photo: {
              filename: ""
            }
          },
          options: {
            lang: null,
          }
        }
      ],
      searchInput: "",
      userInfo: {
        id: "999",
        role: "user",
        interface_lang: "EN"
      }
    }
  },
  computed: {
    allQuizzesTags() {
      const uniqueTags = [];
      this.quizzesData?.forEach(obj => {
        obj.tags?.forEach(tag => {
          if (!uniqueTags.includes(tag)) {
            uniqueTags.push(tag);
          }
        });
      });
      return uniqueTags
    },
  },
  methods: {
    nameNewQuizMethod() {
      const quizName = localStorage.getItem('templateQuizName');
      return quizName
    },
    getCheckedTags() {
      const radioContainer = document.getElementById('tags_wrap');
      // const checkboxes = checkboxesContainer.querySelectorAll('input[type="checkbox"]:checked');
      const radio = radioContainer.querySelectorAll('input[type="radio"]:checked');
      const checkedTags = Array.from(radio).map(checkbox => checkbox.value);
      return checkedTags;
    },
    handleCheckboxClick() {
      const checkedTags = this.getCheckedTags();
      this.searchInput = "";

      this.quizzesData.forEach(obj => {
        const item = document.getElementById('template_quiz_' + obj.id);
        if (item) {
          item.style.display = "";
        }
      });

      if (checkedTags[0] === "all_tags") {
        this.quizzesData.forEach(obj => {
          const item = document.getElementById('template_quiz_' + obj.id);
          if (item) {
            item.classList.add('show');
            item.classList.remove('hide');
          }
        });
      } else if (checkedTags[0] === "no_tags") {
        this.quizzesData.forEach(obj => {
          const item = document.getElementById('template_quiz_' + obj.id);
          if (item) {
            if (!obj.tags || obj.tags.length === 0) {
              item.classList.add('show');
              item.classList.remove('hide'); // Показываем элемент без тегов
            } else {
              item.classList.add('hide');
              item.classList.remove('show'); // Скрываем элемент с тегами
            }
          }
        });
      } else {
        this.$refs.templatesScrollWrap.$el.scrollTop = 0;
        this.quizzesData.forEach(obj => {
          const item = document.getElementById('template_quiz_' + obj.id);
          if (item) {
            if (checkedTags.every(tag => obj.tags.includes(tag))) {
              item.classList.add('show');
              item.classList.remove('hide'); // Показываем элемент
            } else {
              item.classList.add('hide');
              item.classList.remove('show'); // Скрываем элемент
            }
          }
        });
      }
    },
    clickSearchButton() {
      const tagCheckboxes = document.getElementsByClassName('tag-checkbox');
      for (let i = 0; i < tagCheckboxes.length; i++) {
        tagCheckboxes[i].checked = false;
      }
      const searchText = this.searchInput.toLowerCase();
      this.filterItemsBySearch(searchText);
      this.$refs.templatesScrollWrap.$el.scrollTop = 0;
    },
    filterItemsBySearch(searchText) {
      const searchWords = searchText.toLowerCase().split(' ');
      this.quizzesData.forEach(item => {
        const itemText = item.name.toLowerCase();
        const itemId = item.id;
        const htmlItem = document.getElementById('template_quiz_' + itemId);
        const obj = this.quizzesData.find(obj => obj.id === itemId);
        if (obj) {
          const tagsText = obj.tags.join(' ').toLowerCase();
          const containsAllWords = searchWords.every(word => {
            // Вариант 3
            // const regex = new RegExp(word.slice(0, -2), 'i');
            // return (
            //     itemText.includes(word) ||
            //     tagsText.includes(word) ||
            //     obj.tags.some(tag => tag.includes(word))
            // );

            // Вариант 2
            // Игнорируем несоответствие последних символов в словах
            const regex = new RegExp(word.slice(0, -2), 'i');
            return regex.test(itemText) || regex.test(tagsText);

            // Вариант 1
            // Проверяем, содержит ли текстовое содержимое элемента или текст тегов объекта каждое из слов поискового запроса
            // return itemText.includes(word) || tagsText.includes(word);
          });
          if (containsAllWords) {
            htmlItem.style.display = 'block'; // Показываем элемент
          } else {
            htmlItem.style.display = 'none'; // Скрываем элемент
          }
        }
      });
    },
    addDefaultData(id, code, domain, name) {
      var data = JSON.stringify({
        query: `mutation {
                    updateQuiz (id:"` + id + `", domain:"` + domain + `", name: "` + name + `"){
                        id
                        name
                        code
                        domain
                    }
                }`,
        variables: {}
      });
      var config = {
        method: 'post',
        url: this.baseBackendUrl + '/graphql/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
          .then(response => {
            this.errorAuth(response.status)
            this.$router.push(code + '/constructor')
          })
          .catch(error => {
            console.log(error);
            this.errorAuth(error.response.status)
          });
    },
    duplicateQuiz(id, name) {
      this.$emit('showLoader')
      var data = JSON.stringify({
        query: `mutation {
                    copyQuiz(id:` + id + `){
                        id
                        code
                        domain
                        created_at
                        name
                    }
                }`,
        variables: {}
      });

      var config = {
        method: 'post',
        url: this.baseBackendUrl + '/graphql/',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
          .then(response => {
            this.errorAuth(response.status)
            let copiedQuizDomain = (((response.data.data.copyQuiz.code).toLowerCase()) + '.adsquiz.io')
            let copiedQuizId = response.data.data.copyQuiz.id
            let quizCode = response.data.data.copyQuiz.code
            let quizName = ""
            let nameNewQuiz = this.nameNewQuizMethod()
            if (nameNewQuiz) {
              quizName = nameNewQuiz
            } else {
              quizName = name
            }
            this.addDefaultData(copiedQuizId, quizCode, copiedQuizDomain, quizName)
            this.$emit('hideLoader')
          })
          .catch(error => {
            console.log(error);
            this.errorAuth(error.response.status)
          });
    },
    getQuizzesData() {
      this.fullScreenLoader = true;
      // quizzes(is_template:true, lang: "` + this.$i18n.locale + `") {
      var queryData = JSON.stringify({
        query: `query{
                    quizzes(limit:100, page:1, is_template:true, lang: "` + (this.selectedTemplateLocale.toLowerCase()) + `") {
                        data {
                            id
                            code
                            domain
                            is_template
                            tags
                            name
                            start_page {
                                description
                                photo{filename}
                            }
                            options {
                                lang
                            }
                        }
                    }
                    users (` + this.baseUserIdent + `) {
                        id
                        role
                        interface_lang
                    }
                }`,
        variables: {}
      });

      var reciveQuizzes = {
        method: 'post',
        url: this.baseBackendUrl + '/graphql',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: queryData,
        withCredentials: true
      };

      axios(reciveQuizzes)
          .then(response => {
            this.quizzesData = response.data.data.quizzes.data
            delay(() => {
              this.opacityBody = '1'
            }, 10);
            this.userInfo = response.data.data.users[0]
            this.errorAuth(response.status)
            this.fullScreenLoader = false;
          })
          .catch(error => {
            console.log(error);
            console.log(error.response.status)
            let statusError = error.response.status
            this.errorAuth(statusError)
            this.fullScreenLoader = false;
          });
    },
    updateUserLang(locale) {
      var data = JSON.stringify({
        query: `mutation {
                updateUser(
                    id: "` + this.userInfo.id + `",
                    interface_lang: "${locale}",
                )
                {
                    id
                    interface_lang
                }
            }`,
        variables: {}

      });

      var config = {
        method: 'post',
        url: this.baseBackendUrl + '/graphql/',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: data
      };

      axios(config)
          .then(() => {

          })
          .catch(error => {
            this.$notify({
              title: 'Помилка в оновлені даних: "' + this.userInfo.email,
              type: 'error'
            });
            console.log(error);
          })
    },
    changeLocale(locale) {
      this.selectedTemplateLocale = locale;
    },
    createNewQuiz() {
      if (this.isAuthenticated) {
        this.updateUserLang(this.selectedTemplateLocale)
      }
      this.$emit("addNewQuiz", this.selectedTemplateLocale);
    },
    goToQuiz(domain) {
      window.open(`https://${domain}`, '_blank');
    },
    closeModal(){
      this.$emit('close');
    },
  },
  mounted() {
    this.getQuizzesData()
    this.interval = setInterval(() => {
      this.mainContainerHeight = document.getElementById('main-container')?.clientHeight;
      this.topPanelH = document.getElementById('templates_top_panel')?.clientHeight;

      delay(() => {
        this.templatesWrapH = this.mainContainerHeight - this.topPanelH - 32;
      }, 10);
    }, 100);
  },
  beforeRouteLeave() {
    clearInterval(this.interval);
  },
  watch: {
    '$i18n.locale'(newLang) {
      this.selectedTemplateLocale = newLang;
    },
    selectedTemplateLocale() {
      this.getQuizzesData();
    },
  }
}
</script>

<style scoped>

/* style for perfect-scrollbar*/
::v-deep(.ps__thumb-y) {
  background-color: var(--color-main-blue);
}

::v-deep(.ps__rail-y:hover.ps__thumb-y),
::v-deep(.ps__rail-y:focus.ps__thumb-y),
::v-deep(.ps__rail-y.ps--clicking .ps__thumb-y) {
  background-color: var(--color-main-blue);
}

.quiz-new {
  height: 110px;
  color: #808080;
  display: flex;
  background-color: var(--color-main-white);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: var(--border-default);
  cursor: pointer;
}

.templates-board .container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
}

.templates_top_panel {
  padding-bottom: 20px;
  flex: 0 0 20%;
  max-width: 160px;
}

.quiz-by-template_head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 100%;
  max-height: 40px;
  height: 100%;
  align-items: baseline;
}
.header_search_block{
  display: flex;
  flex-direction: row;
  gap: 40px;
  max-width: 440px;
  justify-content: space-between;
  width: 100%;
}
.search-input {
  width: 100%;
  min-width: 440px;
}

.template_search_input {
  height: 34px;
  border-radius: 10px;
  padding: 12px 44px 12px 12px;
  width: 100%;
  font-size: 14px;
  background-image: url("../../views/img/icons/search_template.svg");
  background-position: right 20px center;
  background-repeat: no-repeat;
  background-size: 24px;
}

.template_search_input ::placeholder {
  color: #A6A6A6
}

.templates_tags_wrap-gray {
  gap: 8px;
}

.templates_tags_wrap-gray input {
  display: none;
}

.templates_tags_wrap-gray label {
  display: block;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
}

.templates-board .quizes-scroll-box {
  /* height: calc(100vh - 230px); */
  /* overflow: auto; */
  position: relative;
  flex: 1;
}

.templates-box {
  gap: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(192px, 1fr));
  align-items: flex-start;
}

.quiz-box {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  gap: 0;
  box-shadow: 0px 0px 4px 0px #0000001F;
  position: relative;
  margin: 0;
  transition: outline 0.1s ease;
}

.quiz-box::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(360deg, rgb(95 102 149 / 30%), hsla(0, 0%, 96%, .5));
  z-index: 1;
  pointer-events: none;
  opacity: 0;
  border-radius: 8px;
  transition: opacity 0.3s ease;
}

.quiz-box:hover {
  outline: 1px solid #3749c0;
  border-radius: 8px;
  border: 0;
}

.quiz-box:hover::after {
  opacity: 1;
}

.quiz-icons {
  position: absolute;
  top: 65px;
  left: 50%;
  gap: 10px;
  display: flex;
  justify-content: space-between;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 10;
}

.quiz-box:hover .quiz-icons {
  opacity: 1;
}

.quiz-icons svg {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.quiz-icons svg:hover {
  transform: scale(1.1);
}

.quiz-box.show {
  display: block;
}

.quiz-box.hide {
  display: none;
}

.quiz_template_img-tags_wrap {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  overflow: hidden;
  border-radius: 8px 8px 0 0;
}

.quiz_template_img-tags_wrap .quiz_tags {
  position: absolute;
  left: 0;
  top: 0;
  padding: 12px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  z-index: 9;
}

.quiz_template_img-tags_wrap img {
  height: 110px;
  width: 100%;
  z-index: 1;
  object-fit: cover;
  object-position: center center;
}

.quiz_tags span {
  padding: 4px 8px;
  border-radius: 4px;
  text-align: center;
  white-space: nowrap;
  font-size: 10px;
  font-weight: 600;
}

.quiz_tags span a {
  color: var(--color-main-blue);
}

.qb_body {
  flex-direction: column;
  height: calc(100% - 150px);
  padding: 12px;
  border-radius: 0 0 8px 8px;
}
.quiz-text {
  display: flex;
  align-items: center;
  height: 44px;
  line-height: 17px;
  background-color: var(--color-main-white);
  padding: 4px 8px;
  border-radius: 0 0 8px 8px;
}
.qb_text_block h4 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 4px;
}

.qb_text_block p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
}

.templates-box .qb_body_main-actions {
  width: 100%;
  justify-content: space-between;
  margin-top: 16px;
}

.templates-box .qb_body_main-actions > * {
  width: calc(50% - 4px);
  text-align: center;
  cursor: pointer;
  padding: 8px 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.templates-box .qb_body_main-actions > .btn-default-white {
  border: 1px solid #182D48;
}

.media-board {
  padding-bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #FBFBFB;
}
/* Animation */
@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* @media */
@media screen and (max-width: 1199px) {
  .quiz-box {
    position: relative;
    margin: 0;
    border-radius: 8px;
  }
}

@media screen and (max-width: 992px) {
  .templates-box {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(192px, 1fr));
    gap: 20px;
  }
}

@media screen and (max-width: 720px) {
  .templates_tags_wrap-gray {
    width: 100%;
    overflow-y: visible;
    overflow-x: auto;
    flex-wrap: nowrap;
    align-items: center;
  }
  .search-input{
    width: 100%;
    min-width: 0;
    max-width: 440px;
  }
}

@media screen and (max-width: 420px) {
  .templates-board .container{
    gap: 0;
  }
  .quiz-by-template_head {
    justify-content: space-between;
    flex-direction: column;
    z-index: 10000;
    align-items: baseline;
    flex-wrap: wrap;
    max-height: 80px;
    gap: 0;
  }
  .header_search_block {
    flex-direction: column;
    gap: 10px;
    width: 85%;
  }
  .templates_top_panel {
    display: none;
  }
  .search-input {
    order: 2
  }
  .media-board {
    padding: 10px 0 70px 0;
  }
}
</style>